import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './table-popup.component.scss';
import * as $ from 'jquery';
var TablePopup = /** @class */ (function (_super) {
    tslib_1.__extends(TablePopup, _super);
    function TablePopup(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    TablePopup.prototype.init = function () {
        this.tables = Array.from(this.element.querySelectorAll('.table'));
        this.modals = Array.from(this.element.querySelectorAll('.js-table-popup-modal'));
        this.modalContent = Array.from(this.element.querySelectorAll('.table-popup__modal-content'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-table-popup-modal-open'));
        this.closeButton = this.element.querySelector('.js-table-popup-modal-close');
    };
    TablePopup.prototype.bindEvents = function () {
        // this.tables.map((item) => item.addEventListener('mousewheel', (event) => {
        // 	this.scrollHorizontally(event);
        // }));
        var _this = this;
        // this.tables.map((item) => item.addEventListener('DOMMouseScroll', (event) => {
        // 	this.scrollHorizontally(event);
        // }));
        // this.tables.map((item) => item.addEventListener('onmousewheel', (event) => {
        // 	this.scrollHorizontally(event);
        // }));
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.modalContent.map(function (item) { return item.addEventListener('scroll', function (event) {
            _this.staticHeader();
        }); });
    };
    TablePopup.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    TablePopup.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-table-popup-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    TablePopup.prototype.closeModal = function () {
        var _this = this;
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    TablePopup.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    TablePopup.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    TablePopup.prototype.scrollHorizontally = function (event) {
        event = window.event || event;
        var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        event.currentTarget.scrollLeft -= (delta * 40); // Multiplied by 40
        event.preventDefault();
    };
    TablePopup.prototype.staticHeader = function () {
        var popup = document.querySelector('.js-table-popup-modal-window');
        var table = document.querySelectorAll('.static_header');
        var tableHead = document.querySelectorAll('.static_header thead');
        var tableBody = document.querySelectorAll('.static_header tbody');
        var fixedHeader = document.querySelectorAll('.static_header .fixed');
        // const offset = table.getBoundingClientRect();
        for (var i = 0; i < table.length; ++i) {
            var offsetBody = tableBody[i].getBoundingClientRect();
            var windowOffset = popup.getBoundingClientRect();
            if (windowOffset.top >= offsetBody.top) {
                table[i].classList.add('static_header__top');
                tableHead[i].classList.add('fixed');
                if (popup.clientWidth > 767) {
                    tableHead[i].setAttribute('style', 'top: ' + ((windowOffset.top + 40) - offsetBody.top) + 'px !important;');
                }
                else {
                    tableHead[i].setAttribute('style', 'top: ' + (windowOffset.top - offsetBody.top) + 'px !important;');
                }
            }
            else {
                table[i].classList.remove('static_header__top');
                tableHead[i].classList.remove('fixed');
                tableHead[i].setAttribute('style', '');
            }
            if (windowOffset.top >= offsetBody.bottom) {
                table[i].classList.remove('static_header__top');
                tableHead[i].classList.remove('fixed');
                tableHead[i].setAttribute('style', '');
            }
        }
        if (fixedHeader != null) {
            $(tableBody).find('tr').first().children().each(function (i, e) {
                $($(fixedHeader).find('tr').children()[i]).width($(e).width() - 1);
            });
        }
    };
    return TablePopup;
}(Base));
export { TablePopup };



//////////////////
// WEBPACK FOOTER
// ./components/table-popup/table-popup.component.ts
// module id = 530
// module chunks = 0